import PropTypes from 'prop-types'
import { SectionCardContainer } from './styled-components'

const SectionCard = ({ children }) => <SectionCardContainer>{children}</SectionCardContainer>

SectionCard.propTypes = { children: PropTypes.node }
export default SectionCard
